import { defineStore } from 'pinia';
import { AppModules } from '../types/enums/AppModules';
import { HelloResponse } from '../globals/ServerManager';

// eslint-disable-next-line import/prefer-default-export
export const useAppStore = defineStore({
	id: 'app',
	state: () => ({
		module: '',
		sessionId: '',
		flags: [] as Array<string>,
		baseUrl: document.location.hostname, // Domain
		websocketUrl: '', // WS
		googleTrackingId: 'UA-2440395-3', // UA
		googleAnalyticsData: { userType: 'none' }, // Gtm
		fbTrackingId: '', // Facebook
		userComTrackingId: '', // User.com
	}),
	getters: {
		isAdminModule: (state) => state.module === AppModules.ADMIN,
	},
	actions: {
		update(rsvp: HelloResponse) {
			this.sessionId = rsvp.sessionId || '';
			this.baseUrl = rsvp.baseUrl || document.location.hostname;
			this.websocketUrl = rsvp.baseWebsocketUrl || '';
			this.googleTrackingId = rsvp.ua || 'UA-2440395-3';
			this.googleAnalyticsData = rsvp.analytics || { userType: 'none' };
			this.fbTrackingId = rsvp.facebook || '1439591673009945';
			this.userComTrackingId = rsvp.userComApiKey || '';

			this.updateFlags(rsvp);
		},
		updateFlags(rsvp: HelloResponse) {
			const { user } = rsvp;
			this.flags = rsvp.flags || [];

			// Dodaj flagi do debugu z localStorage
			try {
				const customFlags = window.localStorage.getItem('flags');
				if (customFlags) {
					this.flags.push(...customFlags.split(',') || []);
				}
			} catch (err) {
				window.localStorage.setItem('flags', '');
			}

			// Czy pierwszą stroną mają być Kontakty, czy zapytania?
			if (rsvp.newMessagesSinceLastVisit) {
				rsvp.flags.push('newMessagesSinceLastVisit');
			}

			// Najlepsi 2023
			const awardsDeadline = window.localStorage['awardsDeadline_2023'] || '2023-05-11';
			window.localStorage['awardsDeadline_2023'] = awardsDeadline;
			if (Number(new Date()) < Number(new Date(awardsDeadline))) {
				this.flags.push('the_best_award_season');
			}

			// BuyerView
			if (user) {
				if (user.passwordSet) {
					this.flags.push('buyerPasswordSet');
				}

				if (user.buyerViewNew) {
					this.flags.push('buyerViewNew');
				}

				if (user.phoneConfirmed) {
					this.flags.push('buyerPhoneConfirmed');
				}
			}
		},
		hasFlag(flag:string) {
			return this.flags.indexOf(flag) !== -1;
		},
		addFlag(flag:string) {
			if (!this.hasFlag(flag)) {
				this.flags.push(flag);
			}
		},
		removeFlag(flag: string) {
			const flagIndex = this.flags.findIndex((f: string) => f === flag);
			if (flagIndex >= 0) { this.flags.splice(flagIndex, 1); }
		},
	},
});
